<template>
  <el-dialog title="详情" :visible.sync="dialogVisible">
    <section>
        <el-row>
          <el-col :span="2" >
              <span>卡券名称:</span>
          </el-col>
          <el-col :span="7" >
              <span>{{couponInfo.couponName}}</span>
          </el-col>
          <el-col :span="2" >
              <span>卡券类型:</span>
          </el-col>
          <el-col :span="7" >
              <span>{{CouponTypeLabel}}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top:10px">
          <el-col :span="2" >
              <span>封面图片:</span>
          </el-col>
          <el-col :span="2" >
              <img  :src="couponInfo.couponPicture?couponInfo.couponPicture:require('../../assets/avatar.png')"  min-width="70" height="70" />
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row style="margin-top:10px">
          <el-col :span="2" >
              <span>优惠内容:</span>
          </el-col>
          <el-col :span="7">
              <span>{{couponInfo.couponDetail}}</span>
          </el-col>
        </el-row>
        <el-row  style="margin-top:10px">
           <el-col :span="2" >
              <span>截止时间:</span>
          </el-col>
          <el-col :span="7">
              <span>{{couponInfo.endTime}}</span>
          </el-col>
        </el-row>
        <el-row  style="margin-top:10px">
          <el-col :span="2" >
              <span>使用时间:</span>
          </el-col>
          <el-col :span="7">
              <span>{{couponInfo.canUseTime}}</span>
          </el-col>
        </el-row>
        <el-row  style="margin-top:10px">
          <el-col :span="2" >
              <span>使用说明:</span>
          </el-col>
          <el-col :span="22" >
              <span>{{couponInfo.useDescribe}}</span>
          </el-col>
        </el-row>
      </section>
      <section v-if="userType3">
          <el-divider></el-divider>
          <el-row  style="margin-top:10px">
              <el-col :span="2">
                  <span>卡券状态:</span>
              </el-col>
              <el-col :span="7">
                  <span>{{checkStatus}}</span>
              </el-col>
              <el-col :span="2">
                  <span>热门状态:</span>
              </el-col>
              <el-col :span="7">
                  <span>{{hotFlagLabel}}</span>
              </el-col>
          </el-row>
          <el-row  style="margin-top:10px">
              <el-col :span="2">
                  <span>卡券发放:</span>
              </el-col>
              <el-col :span="4">
                  <span>{{couponInfo.releaseCount}}张</span>
              </el-col>
              <el-col :span="2">
                  <span>卡券领取:</span>
              </el-col>
              <el-col :span="4">
                  <span>{{couponInfo.getNum}}张</span>
              </el-col>
              <el-col :span="2">
                  <span>卡券核销:</span>
              </el-col>
              <el-col :span="4">
                  <span>{{couponInfo.useNum}}张</span>
              </el-col>
          </el-row>
          <el-row  style="margin-top:10px" v-show="showAudit=='1'">
             <el-col :span="24" style="text-algin:center">
                  <el-button type="danger" @click="failPassAudit()">审核不通过</el-button>
				          <el-button type="primary" @click="passAudit()" >审核通过</el-button>
                  <el-button type="default" @click="closeDialog()" >关闭</el-button>
             </el-col>
          </el-row>
    </section>
    
  </el-dialog>
</template>

<script>

  export default {
    name: "couponDetail",
    props: {
      //自定义配置项
      propsData: {
          type: Object,
          default: () => {}
      },
      showAudit:{
          type:String,
          default:'1'
      }
    },
    watch: {
      propsData(val) {
        
        this.getCouponInfo();
        this.getUserInfo();
        this.dialogVisible =true;
      },
    },
    data() {
      return {
        dialogVisible:false,
        CouponTypeLabel:'',
        checkStatus:'',
        hotFlagLabel:'',
        couponInfo:{
          CouponTypeLabel:'',
        },
        hotFlags:[{ label: '-', value: 0 }, { label: '显示', value: 1 },],
        CouponTypes:[{ label: '代金券', value: 1 }, { label: '免单卡', value: 2 },],
        checkStatuss:[{ label: '未审核', value: '1' }, { label: '审核未通过', value: '2' }, { label: '审核通过', value: '3' }],
        userType3:true,
      }
    },
    methods: {
      openDia(){
          this.dialogVisible =true;
          this.getCouponInfo();
      },
      formartHot(){
        for(let i=0; i< this.hotFlags.length;i++){
          if (this.couponInfo.hotFlag == this.hotFlags[i].value) {
              this.hotFlagLabel = this.hotFlags[i].label;
              break;
          }
        }
      },
      formartCouponType(){
        for(let i=0; i< this.CouponTypes.length;i++){
          if (this.couponInfo.couponType == this.CouponTypes[i].value) {
              this.CouponTypeLabel = this.CouponTypes[i].label;
              break;
          }
        }
      },
      formartCheckStatus(){
        for(let i=0; i< this.checkStatuss.length;i++){
          if (this.couponInfo.checkStatus == this.checkStatuss[i].value) {
              this.checkStatus = this.checkStatuss[i].label;
              break;
          }
        }
      },
      async getUserInfo(){
          let condition ={};
          condition.userId = this.propsData.userId;
          let result =  await this.$http.post(this,'/user/getUserInfoById', {},condition);
          if (result && result.code == 200) {
            
              if(result.data.obj.userType !=1){
                  this.userType3 =true;
              }
					}
      },
      async getCouponInfo(){
          let this_ = this;
          let condition ={}
          condition.couponId = this.propsData.couponId;
          
          let result = await this_.$http.post(this,'/coupon/getCouponDetailById', {},condition);
          if (result && result.code == 200) {
            
              this_.couponInfo = result.data.obj;
              setTimeout(function(){
                  this_.formartCouponType();
                  this_.formartCheckStatus();
                  this_.formartHot();
              },100)
              
					}
      },
      async failPassAudit(){
        let _this =this;
        _this.$prompt('', '不通过的原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
            _this.failPass(value);
        }).catch(() => {
         
        });
      },
      async failPass(value){
        let couponList = [];
        couponList.push(this.propsData.couponId);
        let condition={};
        condition.idList = couponList;
        condition.failReason =value;
        condition.checkStatus = 2;
        let result = await this.$http.post(this,'/coupon/checkCouponInfo', {},condition);
        if (result && result.code == 200) {
          this.dialogVisible =false;
          this.$emit('fatherMethod');
        }
      },
      async passAudit(){
        let couponList = [];
        couponList.push(this.propsData.couponId);
        let condition={};
        condition.idList = couponList;
        condition.checkStatus = 3;
        let result = await this.$http.post(this,'/coupon/checkCouponInfo', {},condition);
        if (result && result.code == 200) {
          this.dialogVisible =false;
          this.$emit('fatherMethod');
        }
      },
      closeDialog(){
        this.dialogVisible =false;
        this.$emit('fatherMethod');
      }
    },
    created() {
         this.getUserInfo();
         this.getCouponInfo();
         this.dialogVisible =true;
    }
  }
</script>

<style scoped>

  .toolbar {
    background: #f2f2f2;
    padding: 10px;
    margin: 10px 0px;
  }
  .el-form-item {
    margin-bottom: 10px;
    width:20%;
  }


  .icon-class {
    font-size: 30px;
    position: relative;
    vertical-align: sub;
    margin-left: 15px;
  }

  .form-class {
    margin-left: 1%;
  }
</style>
